<template>
<div>
    <b-modal
      size="sm"
      id="expense-modal"
      ref="expense-modal"
      title="Expenses"
      centered
			@ok="submitExpenseLine"
			@hidden="expensesModalReset"
      no-close-on-backdrop
    >
      <b-row>
        <b-col>
          <b-form-group label-cols="3" label-align="right" label="Type">
            <b-form-select v-model="expensesObj.expenseAccountId">
                <option
                  v-for="expenseType in sortSelect(expenseTypes,'accountName')"
                  :key="expenseType.id"
                  :value="expenseType.id"
                >{{expenseType.accountName}}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Payment Account" label-cols="3" label-align="right">
            <b-form-select v-model="expensesObj.paymentAccount">
              <option :value="null"></option>
              <option
                v-for="option in sortSelect(bankAccounts, 'accountName')"
                :key="option.name"
                :value="option.id"
              >{{option.accountName}}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label-cols="3" label-align="right" label="Description">
            <b-form-input v-model="expensesObj.description"  />
          </b-form-group>
          <b-form-group label-cols="3" label-align="right" label="Amount">
            <b-form-input type="number" v-model="expensesObj.amount" />
          </b-form-group>
        </b-col>
      </b-row>
      
      <template slot="modal-footer" slot-scope="{ ok, cancel }">
        <b-button
          v-if="isEdit"
          variant="danger"
          @click="deleteExpenseLine(expenseLineObj.id)"
        >
          Delete
        </b-button>
        <b-button
          variant="secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          :disabled="!(expensesObj.expenseAccountId && expensesObj.amount)"
          variant="primary"
          @click="ok()"
        >
          OK
        </b-button>
      </template>
    </b-modal>
    <div class="d-flex justify-content-end mb-3">
      <b-button @click="openExpensesModal" size="sm" variant="primary">
        <i class="fa fa-plus" aria-hidden="true"></i>
        Add New
      </b-button>
    </div>
    <grid-component
      isResizable
      isReorderable
      isSortable
      :gridId="gridId"
      :navigationField="'accountName'"
      :itemData="expenselines"
      :fields="fields"
      :onEdit="editExpensesModal"
      :onDelete="deleteExpenseLineGrid"
     />
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from './fields';
import {GRID_ID} from '@/shared/constants';
import { ACCOUNT_TYPES } from '@/pages/Accounting/components/ChartsOfAccounts/constants';

export default {
  components: {
    GridComponent
  },
  props: {
    invoiceId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      expensesObj: {
				id: 0,
				paymentId: 0,
        expenseAccountId: null,
        paymentAccount: 0,
        amount: null,
        active: true,
			},
			expenseLineObj: {
				id: 0,
				invoiceId: 0,
				expenseId: 0,
				description: null,
				amount: null,
				active: true
			},
      fields: gridFields,
      isEdit: false,
      okButtonDisabled: true,
      expenseAccts: 7,
      gridId: '',
      bankAccounts: []
    }
  },
  computed: {
		...mapGetters('expenseLines', ['invoiceExpenseLines']),
    ...mapState('chargesList', ['expenseAndIncomeAccounts']),
    ...mapGetters('serviceOrderLines', ['serviceOrderLine']),
    ...mapGetters('quickBooks', ['qboPaymentMethods']),
    expenseTypes() {
      return this.expenseAndIncomeAccounts.filter(x => x.accountTypeId == this.expenseAccts).sort((a, b) => (a.accountName > b.accountName) ? 1 : -1)
    },
    expenselines() {
			return this.invoiceExpenseLines;
    },
  },
  methods: {
		...mapActions('expenseLines', [
			'getExpenseLineByInvoiceId',
			'addNewExpenseLine',
			'deleteExpenseLineById',
			'editExpenseLineById'
    ]),
    ...mapActions('chartsOfAccounts', ['getMultiAccounts']),
		...mapActions('expenses', ['manage', 'deleteRecord']),
    ...mapActions('chargesList', ['getExpenseAndIncomeCharges']),
  	openExpensesModal() {
      this.$refs['expense-modal'].show();
    },
    editExpensesModal(props) {
      this.isEdit = true;
			this.expenseLineObj = { ...props };
      this.expensesObj = { 
				...props,
				id: props.expenseId
			};

      this.okButtonDisabled = false;

      this.openExpensesModal();
    },
    async submitExpenseLine() {
			let tempExpLineObj = {
					id: this.expenseLineObj.id,
					invoiceId: this.invoiceId,
					description: this.expensesObj.description,
					amount: this.expensesObj.amount,
					active: 1
			};
			let isEdit = this.isEdit;
			delete this.expensesObj.description;
      const expenseId = await this.manage(this.expensesObj);
      if (expenseId > 0) {
        tempExpLineObj = { ...tempExpLineObj, expenseId };
        if(isEdit) {
          await this.editExpenseLineById(tempExpLineObj);
        } else {
          await this.addNewExpenseLine(tempExpLineObj);
        }

        this.$snotify.success('Expense successfully saved');

        this.$emit('updateExpense');
      }

			this.$refs['expense-modal'].hide();
			this.expenseLinesList();
    },
    async deleteExpenseLineGrid({ id }) {
      await this.deleteExpenseLine(id);

    },
    async deleteExpenseLine(id) {
      const deleteConfirmed = await this.openConfirmBox({message: 'Are you sure you want to delete expense?'});
      if (deleteConfirmed) {
        const result = await this.deleteExpenseLineById(id);
				//this.$emit('updateTotal',quoteSummary);
				this.expensesObj = {};
				this.$snotify.success('Expense successfully deleted');
        this.$refs['expense-modal'].hide();
        await this.expenseLinesList();
        this.$emit('updateExpense');
      }
      this.expensesObj = {};
    },
    async expenseLinesList() {
			if (this.invoiceId) {
				this.gridId = GRID_ID.INVOICE_EXPENSES_GRID;
				this.expenseLineObj = { ...this.expenseLineObj, invoice: this.invoiceId };
				await this.getExpenseLineByInvoiceId(this.invoiceId);
			}
    },
    expensesModalReset() {
      this.expensesObj = {
				id: 0,
				paymentId: 0,
        expenseAccountId: null,
        paymentAccount: null,
        amount: null,
        active: true,
			};
			this.expenseLineObj= {
				id: 0,
				invoiceId: this.invoiceId,
				expenseId: 0,
				description: null,
				amount: null,
				active: true
			};

      this.isEdit = false;

      this.okButtonDisabled = true;
    },
  },
  async mounted() {
		this.gridId = GRID_ID.INVOICE_EXPENSES_GRID;
    this.expenseLineObj = { ...this.expensesObj, invoice: this.invoiceId };
    this.getMultiAccounts([
      `accountIds=${ACCOUNT_TYPES["Bank"]}`, 
      `accountIds=${ACCOUNT_TYPES["Credit Card"]}`, 
      `accountIds=${ACCOUNT_TYPES["Other Current Asset"]}`
    ]).then((result) => this.bankAccounts = result.data);
    this.expenseLinesList();
    this.getExpenseAndIncomeCharges();    
  }

}
</script>